/**
 * ============================================================
 *  BYO CART ENHANCER — OPTION C (FUTURE-PROOF) — DO NOT TOUCH
 * ============================================================
 */

(function () {
  if (window.__BYO_CART_OPTION_C_LOADED__) return;
  window.__BYO_CART_OPTION_C_LOADED__ = true;

  // ✅ REMOVED: top-level BLEND BREAKDOWN block (it referenced byoItem/details/sizeEl before they exist)

  const CONFIG = {
    BYO_PRODUCT_ID: "8549893177515",
    CARRIER_VARIANT_ID: "45956039901355",
    BYO_URL: "/products/build-your-own-dried-fruit-mix",
    ALL_PRODUCTS_URL: "/collections/all",
    PRICE_FONT_SIZE_DESKTOP: "1.55rem",
    PRICE_FONT_SIZE_MOBILE: "1.35rem",
    SELECTORS: {
      rowByProductId: (id) => `[data-product-id="${id}"]`,
      details: [".cart-item__details", "td"],
      removeBtn: [".cart-item__remove", 'a[href*="remove"]'],
      mediaWrap: [".cart-item__media", ".cart-item__image", ".cart-item__info", ".cart-item__title"]
    }
  };

  const DEBUG = !!window.__BYO_DEBUG__;
  const log = (...a) => DEBUG && console.log("[BYO Option C]", ...a);

  /* ---------------- HELPERS ---------------- */

  async function getCart() {
    return fetch("/cart.js", { credentials: "same-origin" }).then(r => r.json());
  }

  const money = c => `$${(c / 100).toFixed(2)}`;
  const isMobile = () => window.matchMedia("(max-width:768px)").matches;

  function findRowByProductId(id) {
    return document.querySelector(CONFIG.SELECTORS.rowByProductId(id));
  }

  // ✅ Keep only ONE copy (removed the duplicate)
  function findDetailsContainer(row) {
    for (const sel of CONFIG.SELECTORS.details) {
      const el = row.querySelector(sel);
      if (el) return el;
    }
    return null;
  }

  function hideCarrierRowByLine(carrierItem) {
    if (!carrierItem) return;

    const line = carrierItem.line; // 1-based
    if (!line) return;

    // Common patterns across themes:
    const selectors = [
      `[data-line="${line}"]`,
      `[data-index="${line}"]`,
      `[data-cart-item-index="${line}"]`,
      `a[href*="line=${line}"][href*="quantity=0"]`,
      `a[href*="line=${line}"]`,
      `button[name="updates[]"][data-line="${line}"]`,
      `input[name="updates[]"][data-line="${line}"]`,
      `input[data-line="${line}"]`,
      `input[name^="updates["][data-line="${line}"]`
    ];

    let hit = selectors.map(s => document.querySelector(s)).find(Boolean);

    // Fallback: find any link containing line=#
    if (!hit) {
      hit = [...document.querySelectorAll('a[href*="line="]')].find(a =>
        a.getAttribute("href")?.includes(`line=${line}`)
      );
    }

    if (!hit) return;

    // Climb to a likely cart row wrapper
    const row =
      hit.closest(".cart-item") ||
      hit.closest("tr") ||
      hit.closest("li") ||
      hit.closest('[data-cart-item]') ||
      hit.closest('[class*="cart"]') ||
      hit.parentElement;

    if (row) row.style.setProperty("display", "none", "important");
  }

  /* -------- BLEND READER -------- */
  function getBlendLines(byoItem) {
    const props = byoItem?.properties || {};
    const raw =
      props["Your blend"] ||
      props["Blend"] ||
      props["_Blend"] ||
      "";

    return String(raw)
      .split(/\r?\n/)
      .map(s => s.trim())
      .filter(Boolean);
  }

  /* ---------------- SIZE LABEL ---------------- */

  function getMixSizeLabel(byoItem, details) {
    const props = byoItem?.properties || {};
    const raw =
      props["Bag size"] ||
      props["Size"] ||
      props["_Bag size"] ||
      props["_Size"] ||
      props["_Total weight"] ||
      "";

    if (raw) return String(raw).trim();

    const txt = details?.innerText || "";
    const m = txt.match(/Size:\s*([0-9]+\s*(g|kg))/i);
    return m ? m[1].replace(/\s+/g, "") : "";
  }

  /* ---------------- EDIT URL ---------------- */

function buildEditMixURL(byoItem) {
  try {
    const state = byoItem?.properties?._BYO_STATE;
    const group = byoItem?.properties?._byo_group;

    if (!state) return CONFIG.BYO_URL;

    let url = `${CONFIG.BYO_URL}?_BYO_STATE=${encodeURIComponent(String(state))}`;

    if (group) {
      url += `&_BYO_GROUP=${encodeURIComponent(String(group))}`;
    }

    return url;
  } catch {
    return CONFIG.BYO_URL;
  }
}

  /* ---------------- CLEANUP ---------------- */

  function cleanBYOLines(details) {
    details.querySelectorAll("*").forEach(node => {
      const t = (node.textContent || "").trim();
      if (!t) return;

      // remove the theme's property render for "Your blend"
      if (/^Your blend:/i.test(t)) {
        node.remove();
        return;
      }

      // remove other BYO system lines
      if (
        /^Bag size:/i.test(t) ||
        /^Size:\s*$/i.test(t) ||
        /^\d+\s*(g|kg)$/i.test(t) ||
        t.includes("_BYO_STATE")
      ) {
        node.remove();
      }
    });
  }

  // ✅ Reorder ONLY the injected blend breakdown lines
  function reorderIngredientBullets(details) {
    const bullets = [...details.querySelectorAll(".byo-blend-breakdown li")];
    if (!bullets.length) return;

    bullets.sort((a, b) => {
      const ga = parseInt(a.textContent.match(/(\d+)\s*g/i)?.[1] || 9999, 10);
      const gb = parseInt(b.textContent.match(/(\d+)\s*g/i)?.[1] || 9999, 10);
      return ga - gb;
    });

    bullets.forEach(li => bullets[0].parentElement.appendChild(li));
  }

  /* ---------------- UI INJECTION ---------------- */

  function injectBYOUI(byoRow, byoItem, carrierItem) {
    const details = findDetailsContainer(byoRow);
    if (!details) return;

    cleanBYOLines(details);
    // ✅ Removed early reorder call (it ran before list existed)

    /* PRICE */
    let priceEl = details.querySelector(".byo-price");
    if (!priceEl) {
      priceEl = document.createElement("div");
      priceEl.className = "byo-price";
      details.prepend(priceEl);
    }

    priceEl.style.cssText = `
      display:flex;
      align-items:flex-start;
      justify-content:space-between;
      gap:12px;
      font-weight:900;
      font-size:${isMobile() ? CONFIG.PRICE_FONT_SIZE_MOBILE : CONFIG.PRICE_FONT_SIZE_DESKTOP};
      margin-bottom:4px;
    `;
    priceEl.innerHTML = `<span class="byo-price-value">${money(carrierItem.final_line_price)}</span>`;

    /* SIZE */
    const mixSize = getMixSizeLabel(byoItem, details);
    let sizeEl = details.querySelector(".byo-size-line");
    if (!sizeEl) {
      sizeEl = document.createElement("div");
      sizeEl.className = "byo-size-line";
      priceEl.after(sizeEl);
    }
    sizeEl.textContent = mixSize ? `Size: ${mixSize}` : "Size:";

    /* BLEND BREAKDOWN (inject first, then reorder) */
    const blendLines = getBlendLines(byoItem);
    let blendEl = details.querySelector(".byo-blend-breakdown");

    if (blendLines.length) {
      if (!blendEl) {
        blendEl = document.createElement("ul");
        blendEl.className = "byo-blend-breakdown";
        sizeEl.after(blendEl);
      }

      blendEl.innerHTML = blendLines.map(line => `<li>${line}</li>`).join("");
      blendEl.style.cssText = `
        margin: 8px 0 0;
        padding-left: 18px;
        color: #2f3a2f;
        font-weight: 600;
        font-size: 14px;
        line-height: 1.35;
      `;

      // ✅ NOW reorder, because items exist
      reorderIngredientBullets(details);
    } else {
      blendEl?.remove();
    }

    /* NOTICE */
    if (!details.querySelector(".byo-total-inline")) {
      const note = document.createElement("div");
      note.className = "byo-total-inline";
      note.innerHTML = mixSize
        ? `✔ Your Personalised Blend total (${mixSize}) is included in the price`
        : `✔ Your Personalised Blend total is included in the price`;
      note.style.cssText = `
        margin-top:8px;
        padding:8px;
        background:#f3f7f1;
        border-left:4px solid #7fb069;
        font-weight:700;
      `;
      details.appendChild(note);
    }

    /* ACTIONS */
    if (!details.querySelector(".byo-actions")) {
      const actions = document.createElement("div");
      actions.className = "byo-actions";
      actions.innerHTML = `
        <a href="${buildEditMixURL(byoItem)}" class="byo-btn">✏️ Edit my blend</a>
        <a href="${CONFIG.BYO_URL}" class="byo-btn primary">➕ Build another Personalised Blend</a>
        <a href="${CONFIG.ALL_PRODUCTS_URL}" class="byo-btn">🛍 Continue shopping</a>
      `;
      details.appendChild(actions);

      const style = document.createElement("style");
      style.textContent = `
        .byo-actions { display:grid; gap:10px; margin-top:10px }
        .byo-btn {
          padding:10px 14px;
          border-radius:999px;
          font-weight:800;
          text-align:center;
          background:#eef5ea;
          color:#1f2d1f;
          text-decoration:none;
        }
        .byo-btn.primary {
          background:#7fb069;
          color:#fff;
        }
      `;
      details.appendChild(style);
    }
  }

  /* ---------------- DELETE (SAFER + FASTER) ---------------- */

  async function deleteBYOAndCarrier(byoItem, carrierItem) {
    await fetch("/cart/update.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        updates: {
          [byoItem.key]: 0,
          [carrierItem.key]: 0
        }
      })
    });

    document.dispatchEvent(new Event("cart:refresh"));
    document.dispatchEvent(new Event("cart:open"));

    location.reload();
  }

  function bindRemoveButton(byoRow, byoItem, carrierItem) {
    const btn = byoRow.querySelector(CONFIG.SELECTORS.removeBtn.join(","));
    if (!btn || btn.dataset.bound) return;
    btn.dataset.bound = "true";

    // ✅ move button to the RIGHT of the injected price line
    const priceRow = byoRow.querySelector(".byo-price");
    if (priceRow) {
      btn.classList.add("byo-delete-btn");
      priceRow.appendChild(btn);
    }

    btn.addEventListener(
      "click",
      e => {
        e.preventDefault();
        e.stopImmediatePropagation(); // ✅ stops theme remove handler too
        deleteBYOAndCarrier(byoItem, carrierItem);
      },
      true
    );

    // ✅ add styling once
    if (!document.getElementById("byo-delete-style")) {
      const style = document.createElement("style");
      style.id = "byo-delete-style";
      style.textContent = `
        .byo-delete-btn{
          margin-left:auto;
          display:inline-flex;
          align-items:center;
          justify-content:center;
          width:28px;
          height:28px;
          border-radius:8px;
          color:#666;
          text-decoration:none;
          background:#f2f2f2;
          border:1px solid #e5e5e5;
          cursor:pointer;
          padding:0;
        }
        .byo-delete-btn:hover{
          color:#b00000;
          border-color:#b00000;
          background:#fff5f5;
        }
      `;
      document.head.appendChild(style);
    }
  }

  /* ---------------- CART CHECKOUT NOTE ---------------- */

  function injectCheckoutNote() {
    // Try common cart footer / checkout areas across themes
    const targets = [
      document.querySelector(".cart__footer"),
      document.querySelector(".cart-footer"),
      document.querySelector(".cart-drawer__footer"),
      document.querySelector(".drawer__footer"),
      document.querySelector("#CartDrawer .drawer__footer"),
      document.querySelector("#CartDrawer .cart-drawer__footer"),
      document.querySelector("form[action^='/cart']")
    ].filter(Boolean);

    if (!targets.length) return;

    // Avoid duplicates
if (document.querySelector(".byo-checkout-note")) return;

const note = document.createElement("div");
note.className = "byo-checkout-note";

note.innerHTML = `
  <strong>Pricing note:</strong>
  Priced by weight. Quantity shown reflects portion units — you’re purchasing one custom blend at the total displayed.
`;

note.style.cssText = `
  font-size: 1rem;
  color: #4a3f00;
  line-height: 1.5;
  margin: 12px 0 14px;
  padding: 12px 14px;
  background: #fff8cc;
  border-left: 4px solid #f4c430;
  border-radius: 10px;
  font-weight: 600;
`;

    // Insert near the checkout button if possible, otherwise append to footer
    const checkoutBtn =
      document.querySelector("button[name='checkout']") ||
      document.querySelector("button[type='submit'][name='checkout']") ||
      document.querySelector("a[href*='checkout']");

    if (checkoutBtn && checkoutBtn.parentElement) {
      checkoutBtn.parentElement.insertBefore(note, checkoutBtn);
      return;
    }

    // fallback: put it at the top of the first footer-like target
    targets[0].prepend(note);
  }

  /* ---------------- INIT ---------------- */

  async function init() {
    const cart = await getCart();

    const byoItem = cart.items.find(i => String(i.product_id) === CONFIG.BYO_PRODUCT_ID);

    const carrierItem =
      cart.items.find(i => i.properties && i.properties._byo_carrier === "true") ||
      cart.items.find(i => String(i.variant_id) === CONFIG.CARRIER_VARIANT_ID);

    if (!byoItem || !carrierItem) return;

    const row = findRowByProductId(CONFIG.BYO_PRODUCT_ID);
    if (!row) return;

    // Hide carrier row if theme uses product-id rows
    hideCarrierRowByLine(carrierItem);
    injectBYOUI(row, byoItem, carrierItem);
    bindRemoveButton(row, byoItem, carrierItem);
    injectCheckoutNote();
  }

  document.readyState === "loading"
    ? document.addEventListener("DOMContentLoaded", init)
    : init();
})();
